var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import { FormattedMessage, FormattedCurrency, injectIntl } from "@irati/utils/lang";
import Card from "@irati/ui/src/Layout/Card";
import { H3 } from "@irati/ui/src/Headings";
import { PriceInput, ValidationButton } from "@irati/ui/src/FormItem";
import ErrorText from "@irati/ui/src/ErrorText";
import { Caption } from "@irati/ui/src/Labels";
import Validation from "@irati/utils/validation";
var AvailableBalance = styled(H3)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 45px;\n  line-height: 50px;\n  text-align: center;\n"], ["\n  color: ", ";\n  font-size: 45px;\n  line-height: 50px;\n  text-align: center;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.brand.default;
});
var StyledCaption = styled(Caption)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: center;\n  text-transform: uppercase;\n"], ["\n  text-align: center;\n  text-transform: uppercase;\n"])));
var StyledErrorText = styled(ErrorText)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: 15px;\n"], ["\n  margin-top: 15px;\n"])));
var Sidebar = /** @class */ (function (_super) {
    __extends(Sidebar, _super);
    function Sidebar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Sidebar.prototype.render = function () {
        var _a = this.props, formatMessage = _a.formatMessage, wallet = _a.wallet, amount = _a.amount, recipients = _a.recipients, load = _a.load, error = _a.error, onChange = _a.onChange, onSubmit = _a.onSubmit;
        var availableBalance = wallet.availableBalance, currency = wallet.currency;
        return (React.createElement(Card, null,
            React.createElement(StyledCaption, { flush: true },
                React.createElement(FormattedMessage, { id: "wallet.sendCredit.availableBalance.title" })),
            React.createElement(AvailableBalance, null,
                React.createElement(FormattedCurrency, { isCents: false, currency: currency, value: availableBalance })),
            React.createElement(StyledCaption, null,
                React.createElement(FormattedMessage, { id: "wallet.sendCredit.availableBalance.footer" })),
            React.createElement(PriceInput, { currency: wallet.currency, label: "wallet.sendCredit.amount.label", name: "SendCreditAmount", min: "0", onChange: onChange, step: "0.01", value: amount, validation: Validation.number("platform.defaultValidation.required")
                    .min(0.01, "wallet.sendCredit.amount.validation.min")
                    .max(Number(availableBalance), "wallet.sendCredit.amount.validation.max") }),
            React.createElement(ValidationButton, { disabled: recipients.length < 1, primary: true, large: true, full: true, onClick: onSubmit, load: load }, formatMessage({ id: "wallet.sendCredit.button" })),
            error && React.createElement(StyledErrorText, null, formatMessage({ id: error }))));
    };
    return Sidebar;
}(PureComponent));
export default injectIntl(Sidebar);
var templateObject_1, templateObject_2, templateObject_3;
